import React, { useEffect, useMemo } from 'react'
import PropTypes from 'prop-types'
import scriptLoader from 'react-async-script-loader'
import config from 'config'
import { useForm } from 'react-hook-form'

import FilterForm from 'student-loan/shared/filter-form'
import LendersList from 'components/lenders-list'
import { fireGtmEvent } from 'utils/gtm'
import { loadLendersRates, filterByLoanAmount } from 'common/utils/rates'
import { getCtaUrl } from 'student-loan/shared/utils'

import { getOrderedLenders } from './utils'
import { INITIAL_VALUES, VERTICAL } from '../const'

const FullRateTableApp = (props) => {
  const {
    widgetContext,
    isScriptLoaded,
    availableLenders = [],
    theme,
    isOrderedRateTable = false,
    metaQuery,
    utms,
  } = props
  const { control, reset, watch } = useForm({ defaultValues: INITIAL_VALUES, mode: 'onChange' })
  const [loanAmount, role] = watch(['loanAmount', 'role'])

  useEffect(() => {
    fireGtmEvent('fieldChange', { loanAmount, ...widgetContext })
  }, [loanAmount]) // eslint-disable-line

  useEffect(() => {
    fireGtmEvent('fieldChange', { role, ...widgetContext })
  }, [role]) // eslint-disable-line

  const resetFilters = () => {
    reset(INITIAL_VALUES)
  }

  /* Get rates from Rates Update library. */
  const lenders = useMemo(() => {
    /* Get the rates after loading the ratesLibrary JS and do it only once. */
    if (isScriptLoaded) {
      return loadLendersRates({
        availableLenders: availableLenders.filter(filterByLoanAmount(loanAmount)),
        filters: { vertical: VERTICAL },
      })
    }

    return []
  }, [isScriptLoaded, availableLenders, loanAmount])

  const orderedLenders = getOrderedLenders(lenders)

  const ctaUrl = getCtaUrl({ utms, theme, metaQuery, role })

  return (
    <div>
      <FilterForm control={control} />
      <LendersList
        lenders={isOrderedRateTable ? orderedLenders : lenders}
        ctaUrl={ctaUrl}
        resetFilters={resetFilters}
        theme={theme}
        name="StudentLoan"
      />
    </div>
  )
}

FullRateTableApp.propTypes = {
  isScriptLoaded: PropTypes.bool,
  utms: PropTypes.shape({
    utm_source: PropTypes.string,
    utm_campaign: PropTypes.string,
    utm_medium: PropTypes.string,
    utm_content: PropTypes.string,
    credclid: PropTypes.string,
    credsessid: PropTypes.string,
    renderId: PropTypes.string,
  }),
  widgetContext: PropTypes.object,
  theme: PropTypes.string,
  metaQuery: PropTypes.string,
  availableLenders: PropTypes.instanceOf(Array),
  isOrderedRateTable: PropTypes.bool,
}

// Export named class for unit tests
export { FullRateTableApp as FullRateTableAppNoHoc }

export default scriptLoader(config.ratesLibraryUrl)(FullRateTableApp)
